// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-card[data-v-63b550d7]{margin-left:auto;margin-right:auto;width:80%}@media (min-width:768px){.v-card[data-v-63b550d7]{width:556px}}@media (min-width:1024px){.v-card[data-v-63b550d7]{width:600px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
